import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { IBranch } from '../interfaces/branch.interface';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class UserService {
  branch!: IBranch;
  branches: IBranch[] = [];
  branchSubject = new BehaviorSubject<any>({});
  userSubject = new BehaviorSubject<any>({});
  
  constructor(private httpClient: HttpClient, private authService: AuthService) { 
    
  }

  getActualUser(): Observable<any> {
    let headers = new HttpHeaders();
    
    if (this.authService.isAuthenticated()) {
      headers = new HttpHeaders({
        'Authorization': `Bearer ${this.authService.getToken()}`
      });
    }
    
    return this.httpClient.get<any>(`${environment.backendUrl}/api/user/actual`, { headers }).pipe(
      tap((response) => {
        this.branches = response.data.uUser?.branches;

        if (response.data.uUser?.defaultBranch) {
          this.branch = response.data.uUser?.defaultBranch;
        } else if (response.data.uUser?.branches) {
          this.branch =  response.data.uUser?.branches[0];
        }

        this.branchSubject.next({ branch: this.branch, branches: this.branches });
        this.userSubject.next(response.data);
      })
    );
  }
}